<template>
<div v-if="data" class="scatter-plot-wrapper">
  <div class="factor-select-group">
    <div class="factor-select-area">
      <div class="factor-select-area-header">选择Y轴因子</div>
      <div class="divider"></div>
      <div class="factor-select-area-body">
        <ul class="factor-group-select-list">
          <li
            v-for="factorGroup in formatFactorGroups"
            :key="factorGroup.id"
          >
            <div class="factor-group-name">{{factorGroup.name}}</div>

            <ul class="factor-select-list">
              <li
                v-for="factor in factorGroup.children"
                :key="factor.id"
                :class="{
                  selected: factor.id === data.factorIdY
                }"
                @click="factorIdChange('factorIdY', factor.id)"
              >{{factor.name}}</li>
            </ul>
          </li>
        </ul>
      </div>
    </div>

    <div class="factor-select-area">
      <div class="factor-select-area-header">选择X轴因子</div>
      <div class="divider"></div>
      <div class="factor-select-area-body">
        <ul class="factor-group-select-list">
          <li
            v-for="factorGroup in formatFactorGroups"
            :key="factorGroup.id"
          >
            <div class="factor-group-name">{{factorGroup.name}}</div>

            <ul class="factor-select-list">
              <li
                v-for="factor in factorGroup.children"
                :key="factor.id"
                :class="{
                  selected: factor.id === data.factorIdX
                }"
                @click="factorIdChange('factorIdX', factor.id)"
              >{{factor.name}}</li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
  </div>

  <div class="scatter-plot-chart">
    <related-chart
      v-if="relatedData"
      :base-data="relatedData.x"
      :related-data="relatedData.y"
      scale
      :data-time-formatter="dataTimeFormatter"
    />
  </div>
</div>
</template>

<script>
import BasePreAnalysis from './BasePreAnalysis'
import RelatedChart from '../../../../../../components/Data/RelatedChart'

export default {
  name: 'ScatterPlot',
  components: {RelatedChart},
  label: '浓度散点图',
  dataKey: 'ScatterPlot',
  extends: BasePreAnalysis,
  data: () => ({
    relatedData: null
  }),
  methods: {
    getDefaultData () {
      const {condition: {factorIds}} = this
      return Promise.resolve({
        factorIdX: factorIds[1] || factorIds[0],
        factorIdY: factorIds[0]
      })
    },
    ready () {
      this.renderChart()
    },
    renderChart () {
      const {data: {factorIdX, factorIdY}, shareData, factorMap} = this
      const xData = shareData[factorIdX]
      const yData = shareData[factorIdY]
      const tsKeys = Object.keys(xData).filter(tsKey => yData[tsKey])

      this.relatedData = Object.freeze({
        x: Object.freeze({
          id: factorIdX,
          name: factorMap[factorIdX].name,
          unit: 'μg/m3',
          data: tsKeys.map(tsKey => {
            const data = xData[tsKey]
            return {
              dataTime: data.dataTime.format('YYYY/MM/DD HH:mm:ss'),
              value: data.conc
            }
          })
        }),
        y: Object.freeze({
          id: factorIdY,
          name: factorMap[factorIdY].name,
          unit: 'μg/m3',
          data: tsKeys.map(tsKey => {
            const data = yData[tsKey]
            return {
              dataTime: data.dataTime.format('YYYY/MM/DD HH:mm:ss'),
              value: data.conc
            }
          })
        })
      })
    },
    factorIdChange (prop, factorId) {
      const {data} = this

      if (data[prop] !== factorId) {
        data[prop] = factorId
        this.renderChart()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.scatter-plot-wrapper {
  display: grid;
  grid-template-columns: minmax(max-content, 40%) auto;
  grid-column-gap: 12px;
  padding-top: 12px;

  > * {
    min: {
      width: 0;
      height: 0;
    }
  }
}

.factor-select-group {
  display: grid;
  grid-template-rows: repeat(2, 1fr);
  grid-row-gap: 12px;

  > * {
    min: {
      width: 0;
      height: 0;
    }
  }
}

.factor-select-area {
  display: grid;
  grid-template-rows: max-content 1px auto;
  border: 1px solid #EBEEF5;

  > * {
    min: {
      width: 0;
      height: 0;
    }
  }

  > .factor-select-area-header {
    font: {
      weight: 700;
    };
    height: 35px;
    line-height: 35px;
    padding-left: 10px;
    color: #303133;
    background-color: #f9f9f9;
  }

  > .divider {
    background-color: #EBEEF5;
  }

  > .factor-select-area-body {
    padding: 3px 0;
    overflow: auto;
  }

  .factor-group-select-list {
    font: {
      size: 14px;
    };
    margin: 0;
    padding: 0;
    line-height: 32px;
    list-style: none;

    > li {
      > .factor-group-name {
        font-weight: bolder;
        /*padding: 0 10px;*/
        text-align: center;
        cursor: default;
      }
    }
  }

  .factor-select-list {
    font: {
      size: 14px;
    };
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    margin: 0;
    padding: 0;
    line-height: 32px;
    list-style: none;

    > li {
      /*padding: 0 20px;*/
      text-align: center;
      cursor: pointer;

      &:hover {
        background-color: #F5F7FA;
      }

      &.selected {
        background-color: #ecf5ff;
      }
    }
  }
}

.scatter-plot-chart {
  padding-top: 20px;
  border: 1px solid #EBEEF5;
}
</style>



// WEBPACK FOOTER //
// src/views/04Statistical-Analysis/11PMF-Analysis/01PM/01Run/preAnalysisComponents/02ScatterPlot.vue